import { api } from '@@/services/api';
import { convertToFormData } from '@@/utils/formData';

export const templateMessageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTemplateMessages: builder.query<Alacaza.TemplateMessage[], void>({
      query: () => `partners/template-messages`,
      providesTags: ['TemplateMessages'],
    }),
    getTemplateMessage: builder.query<Alacaza.TemplateMessage, string>({
      query: (templateMessageId) =>
        `partners/template-messages/${templateMessageId}`,
      providesTags: ['TemplateMessages'],
    }),
    createTemplateMessage: builder.mutation<
      Alacaza.TemplateMessage,
      { title: string; body: string }
    >({
      query: (body) => {
        return {
          url: `partners/template-messages`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['TemplateMessages'],
    }),
    patchTemplateMessage: builder.mutation<
      Alacaza.TemplateMessage,
      Partial<Alacaza.TemplateMessage>
    >({
      query: ({ id, ...body }) => {
        const formData = new FormData();

        return {
          url: `partners/template-messages/${id}`,
          method: 'PATCH',
          body: convertToFormData(body, formData),
          formData: true,
        };
      },
      invalidatesTags: ['TemplateMessages'],
    }),
    deleteTemplateMessage: builder.mutation<{}, string>({
      query: (templateMessageId) => ({
        url: `partners/template-messages/${templateMessageId}`,
        method: 'DELETE',
        body: {},
      }),
      invalidatesTags: ['TemplateMessages'],
    }),
  }),
});

export const {
  useGetTemplateMessagesQuery,
  useGetTemplateMessageQuery,
  useCreateTemplateMessageMutation,
  usePatchTemplateMessageMutation,
  useDeleteTemplateMessageMutation,
} = templateMessageApi;
